import styled from 'styled-components';

const CropDisplay = styled.div`
  font-size: 11px;
  color: #4a4a4a;
  margin: 4px 0;
`;

export default CropDisplay;
